import { type SupportedLocale } from '@zep-us/i18n';

export function joinWithLocale(path: string, locale: SupportedLocale): string {
  // 경로가 "/"로 시작하면 제거하여 중복 "/" 방지
  const cleanedPath = path.startsWith('/') ? path.slice(1) : path;

  // 경로와 로케일을 결합하여 상대 경로를 만듦
  return `/${locale}/${cleanedPath}`;
}
